var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.762 12.632a.766.766 0 0 0 .114-.01l3.188-.559a.186.186 0 0 0 .1-.053L14.2 3.975a.188.188 0 0 0 0-.268L11.05.555A.188.188 0 0 0 10.914.5a.188.188 0 0 0-.135.055L2.745 8.59a.193.193 0 0 0-.053.1l-.56 3.19a.635.635 0 0 0 .179.564.642.642 0 0 0 .45.188ZM4.04 9.326l6.875-6.873 1.39 1.389-6.876 6.873-1.685.298.296-1.687Zm10.518 4.898H.607a.606.606 0 0 0-.607.607v.682c0 .084.068.152.152.152h14.861a.152.152 0 0 0 .152-.152v-.682a.606.606 0 0 0-.607-.607Z",
    fill: "#2360A0"
  })));
};
export default SvgEditIcon;